import { Component, ElementRef, Inject } from '@angular/core';

import { applyStyles } from '../../function/apply-styles.function';
import { CPopTemplateTextElement } from '../../model/c-pop-template-text-element.model';
import { CMPS_EC_TEXT_ELEMENT } from '../../model/metadata';

@Component({
    selector: 'cmps-event-centre-c-pop-text',
    templateUrl: './text.component.html',
    host: {
        class: 'cmps-event-centre-c-pop-text cmps-cdk-d-block',
    },
})
export class TextComponent {
    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        /** @private */ @Inject(CMPS_EC_TEXT_ELEMENT)
        readonly _data: CPopTemplateTextElement,
    ) {
        applyStyles(this._el.nativeElement, this._data.styles);
    }
}
